import { Box, HStack, VStack, Button } from "@chakra-ui/react";
import parseHTML from "html-react-parser";

import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from "antd";
import useDeviceNotifications from "hooks/useDeviceNotifications";
import { FC, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useAuthenticatedRequestCreator } from "hooks/useRequests";

const NotificationsDropdown: FC = () => {
    const { data: tickets } = useDeviceNotifications();
    const [expanded, setExpanded] = useState(false);

    const update = useAuthenticatedRequestCreator<any, any>(() => ({
        method: "post",
        url: "/device/notifications/seen/all",
    }));

    const { mutate: markAllAsSeen, isLoading: markingAllAsSeen } =
        useMutation(update);

    return (
        <Box position="relative">
            <Badge count={tickets?.extra.unreadCount}>
                <Box
                    bgColor="black"
                    rounded="full"
                    padding="3"
                    cursor="pointer"
                    _hover={{
                        outline: "2px solid var(--dcs-blue)",
                    }}
                    as="button"
                    onClick={() => setExpanded((prevState) => !prevState)}
                >
                    <FontAwesomeIcon icon={faBell} color="white" size="xl" />
                </Box>
            </Badge>
            {expanded && (
                <Box
                    position="absolute"
                    border="1px solid gray"
                    rounded="md"
                    bgColor="black"
                    top={14}
                    right={0}
                    padding={2}
                    minWidth={360}
                    zIndex={10}
                >
                    <HStack alignItems="center" justifyContent="center">
                        <Button
                            textAlign="center"
                            color="white"
                            fontWeight="bold"
                            variant="link"
                            onClick={() => {
                                markAllAsSeen({});
                            }}
                            disabled={markingAllAsSeen}
                        >
                            Mark all as seen
                        </Button>
                    </HStack>
                    <Box maxHeight="50vh" width="100%" overflow="scroll">
                        {tickets ? (
                            tickets.data.map((t, i) => {
                                const createdAt = new Date(t.timestamp);
                                const createdAtDate =
                                    createdAt.toLocaleDateString();

                                return (
                                    <HStack
                                        color="white"
                                        padding={2}
                                        paddingBottom={4}
                                        marginX={2}
                                        borderBottom={
                                            i !== tickets.data.length - 1
                                                ? "1px solid white"
                                                : ""
                                        }
                                        key={t.id}
                                        width="calc(100% - 1rem)"
                                    >
                                        {!t.seen && (
                                            <Box minWidth=".5rem">
                                                <Badge dot={!t.seen} />
                                            </Box>
                                        )}
                                        <VStack
                                            alignItems="start"
                                            flex={1}
                                            width="100%"
                                        >
                                            <HStack
                                                width="100%"
                                                justify="space-between"
                                                mb={2}
                                            >
                                                <Box fontWeight="bold">
                                                    {t.title}
                                                </Box>
                                                <Box>{createdAtDate}</Box>
                                            </HStack>
                                            {t.body.html ? (
                                                <Box>
                                                    {parseHTML(t.body.html)}
                                                </Box>
                                            ) : (
                                                <Box>{t.body.text}</Box>
                                            )}
                                        </VStack>
                                    </HStack>
                                );
                            })
                        ) : (
                            <Box> No notifications! </Box>
                        )}
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default NotificationsDropdown;
